module.exports = __webpack_public_path__ + "static/img/error-number-404.c3005a59.svg";